module.exports = __webpack_public_path__ + "img/e.ca34c977.jpg";